<template>
  <div class="template-pagination-container column" :aria-busy="isLoading">
    <loader-line v-if="isLoading"/>
    <div class="template-pagination-wrapper">
      <input-main v-if="isActiveSearch"
                  :info-input="infoInput"
                  @changeValue="value => this.$emit('changeValue', value)"
                  :value="search"/>
      <div class="template-pagination-content">
        <div v-if="isLoading" class="list-loading-state" role="status" aria-live="polite">
          Загрузка…
        </div>
        <slot v-else/>
      </div>
    </div>
    <div class="pagination-container" v-if="!isLoading && pageTotal > 1">
      <pagination
                  :active-page="activePage"
                  @changePage="changeModelPage"
                  :length-pagination="pageTotal"/>
    </div>
  </div>
</template>

<script>

import Pagination from "@/components/shared/Pagination.vue";
import LoaderLine from "@/components/shared/loader/LoaderLine.vue";
import InputMain from "@/components/shared/input/InputMain.vue";

export default {
  name: "TemplatePagination",
  components: {InputMain, LoaderLine, Pagination},
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isActiveSearch: {
      type: Boolean,
      default: true,
    },
    search: {
      type: String
    },
    pageTotal: {
      type: Number,
      required: true
    },
    activePage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      infoInput: {
        placeholder: 'Введите запрос',
        typeInput: 'search',
        key: 'search'
      },
    }
  },
  methods: {
    changeModelPage(page) {
      this.$emit('changePage', page)
    }
  }
}
</script>

<style scoped lang="scss">
  .template-pagination-container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: var(--color-block);
    border-radius: var(--border-radius);
    position: relative;
    height: 100%;

    @media(max-width: 769px) {
      border-radius: 0;
      background-color: var(--color-background);
    }

    .pagination-container {
      max-height: 60px;
      min-height: 60px;
      flex-grow: 1;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 16px 16px;
      background-color: var(--color-block);
      z-index: 1;
    }
    .template-pagination-content {
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      position: relative;
      z-index: 1;
      height: 100%;

      @media(max-width: 769px) {
        padding-top: 8px;
      }


      &::-webkit-scrollbar-thumb {
        background: linear-gradient(90deg, var(--color-block) 30%, var(--color-additional-text) 50.52%, var(--color-block) 70%);
      }
    }
    .list-loading-state {
      min-height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--color-additional-text);
    }
    .template-pagination-wrapper {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      position: relative;
      row-gap: 16px;
      column-gap: 40px;
      z-index: 1;
      &:after {
        content: '';
        position: absolute;
        height: 50%;
        width: 100%;
        bottom: 0;
        z-index: 0;
        background: linear-gradient(rgba(0,0,0,0), var(--color-background) );;
      }
    }
  }

  .input-search {
    width: 50%;
  }
  //
  //@media(max-width: 1280px) {
  //  .template-pagination-container {
  //    flex-direction: column-reverse;
  //  }
  //}
</style>
